import Styled from "styled-components";

export const Wrapper404 = Styled.div`
  width: 70%;
  height: 100vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors?.side};
  text-align: center;

  h1{
    font-size: 100px;
  }
`;
